var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sd-layers-collapse-card"},[(_vm.selectItem_ && _vm.baseLayerInfos.length > 0)?_c('div',{staticClass:"map-switch__layers-wrap"},[_c('sd-fold-cards',{attrs:{"data":_vm.baseLayerInfos,"defaultItem":_vm.selectItem_},on:{"click":_vm.clickItem}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }